import type { HumanoidAppearance } from '../GhostRenderer';
import { npc } from './npc';

/** Wickhaven's working town: moss, weathered teal, charcoal and lamplight brass.
 * IDs remain the service/quest identities; clothing and tools are presentation only. */
export const WICKHAVEN_CAST: Record<string, HumanoidAppearance> = {
  wickhaven_banker: npc({
    shape: 'round', color: '#b98c6c', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'thin', color: '#b7b4a8' },
      beard: { style: 'short', color: '#b7b4a8' },
      garment: { kind: 'tunic', color: '#393744', trimColor: '#c6a25a', beltColor: '#534337' },
      props: [{ kind: 'key_ring', color: '#d4b36a' }, { kind: 'book', color: '#496765' }],
      art: { light: 'lamp', role: 'banker' },
    },
  }),
  wickhaven_grocer: npc({
    shape: 'round', color: '#d7ad87', eyes: 'round', mouth: 'smile',
    humanoid: {
      fit: true,
      hair: { style: 'bun', color: '#a7633c' },
      garment: { kind: 'apron', color: '#467368', underColor: '#e3d6af',
        trimColor: '#c39752', pocketBottles: true },
      props: [{ kind: 'satchel', color: '#76533b' }],
      art: { light: 'lamp', role: 'merchant' },
    },
  }),
  wickhaven_smith: npc({
    shape: 'wide', color: '#b57858', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'short', color: '#3e3936', streakColor: '#aaa396' },
      beard: { style: 'short', color: '#66574c' },
      garment: { kind: 'apron', color: '#3e4244', underColor: '#99563d',
        trimColor: '#92836c', beltColor: '#584333' },
      props: [{ kind: 'hammer', color: '#8f623d', headColor: '#9aa9aa' }],
      art: { light: 'lamp', role: 'local' },
    },
  }),
  wickhaven_lamplighter: npc({
    shape: 'slim', color: '#d1aa85', eyes: 'round', mouth: 'smile',
    humanoid: {
      fit: true,
      hair: { style: 'loose', color: '#493b35', streakColor: '#d7c9a8' },
      cloak: { color: '#344f60', claspColor: '#d6af56' },
      garment: { kind: 'tunic', color: '#b98b3f', trimColor: '#e7cd85', beltColor: '#584739' },
      props: [{ kind: 'lantern', glowColor: '#ffd477' }],
      art: { light: 'lamp', role: 'keeper' },
    },
  }),
  wickhaven_scholar: npc({
    shape: 'slim', color: '#c8b49c', eyes: 'round', mouth: 'neutral', accessory: 'glasses',
    humanoid: {
      fit: true,
      hair: { style: 'thin', color: '#ded9c8' },
      garment: { kind: 'robe', color: '#426c70', trimColor: '#c6ba80', underColor: '#dfd7bd' },
      props: [{ kind: 'book', color: '#584c69' }, { kind: 'satchel', color: '#716148', mapPeek: true }],
      art: { light: 'lamp', role: 'scholar' },
    },
  }),
  wickhaven_warden: npc({
    shape: 'wide', color: '#a98464', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'short', color: '#363d38' },
      beard: { style: 'stubble', color: '#363d38' },
      headgear: { kind: 'warden_hat', color: '#3d5144', accentColor: '#d2a855' },
      cloak: { color: '#35434d', claspColor: '#c8a65c' },
      garment: { kind: 'tunic', color: '#768077', trimColor: '#c6bea1', beltColor: '#493f33' },
      props: [{ kind: 'shield', color: '#5e746c', accentColor: '#c8a65c' }],
      art: { light: 'lamp', role: 'warden' },
    },
  }),
};
